<template>
    <div class="pdf_box">
        <a-spin size="large" :indicator="indicator" tip="Loading..." :spinning="PdftStore.spinning">
            <div class="btn">
                <!-- <a-button @click="changeLanguage">切换为英文报告</a-button> -->
                <!-- <a-button @click="gotopath">返回列表</a-button>
                <a-button @click="getpdf">导出</a-button> -->
            </div>

            <!-- 悬浮按钮 -->
            <div class="box">
                <!-- 返回 -->
                <a-tooltip placement="left">
                    <template #title>
                        <span>返回列表</span>
                    </template>
                    <div class="box-bn" @click="gotopath">
                        <Vicon class="icon" :icon="'arrow-go-back-line'"/>
                    </div>
                </a-tooltip>
                
                <!-- 下载 -->
                <a-tooltip placement="left">
                    <template #title>
                        <span>导出报告</span>
                    </template>
                    <div class="box-bn" @click="getpdf">
                        <Vicon class="icon" :icon="'download-line'"/>
                    </div>
                </a-tooltip>

                <!-- 发送报告 -->
                <a-tooltip placement="left">
                    <template #title>
                        <span>发送报告</span>
                    </template>
                    <div class="box-bn" @click="sentpdf">
                        <Vicon class="icon" :icon="'external-link-line'"/>
                    </div>
                </a-tooltip>
                
                <!-- 返回顶部 -->
                <a-tooltip placement="left">
                    <template #title>
                        <span>返回顶部</span>
                    </template>
                    <div  id="scrollToTopBtn">
                        <div class="box-bn" @click="scrollToTop">
                            <Vicon class="icon" :icon="'arrow-up-line'"/>
                        </div>
                    </div>
                </a-tooltip>
                
            </div>

            <div style="width:1512px;height:32236px" class="pdf" ref="pdf">
                <Page1/>
                <Page2/>
                <Page3/>
                <Page4/>
                <Page5/>
                <Page6/>
                <Page7/>
                <Page8/>
                <Page9/>
                <Page10/>
                <Page11/>
                <Page12/>
                <Page13/>
                <Page14/>
                <!-- <Page15/> -->
                <Page16/>
            </div>
        </a-spin>
    </div>
</template>

<script>
import { reactive, toRefs,ref, onBeforeMount, onMounted, onBeforeUnmount, h } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { downloadPDF, downloadPDF1 } from '@/utils/pdf.js'
import Page1 from './page/page1.vue'
import Page2 from './page/page2.vue'
import Page3 from './page/page3.vue'
import Page4 from './page/page4.vue'
import Page5 from './page/page5.vue'
import Page6 from './page/page6.vue'
import Page7 from './page/page7.vue'
import Page8 from './page/page8.vue'
import Page9 from './page/page9.vue'
import Page10 from './page/page10.vue'
import Page11 from './page/page11.vue'
import Page12 from './page/page12.vue'
import Page13 from './page/page13.vue'
import Page14 from './page/page14.vue'
import Page15 from './page/page15.vue'
import Page16 from './page/page16.vue'
import { usePdftStore } from '@/store/pdf'
import { LoadingOutlined } from '@ant-design/icons-vue';
import Vicon from '@/layout/icon/index.vue'
export default {
    name: 'index',
    components:{Page1, Page2, Page3,Page4, Page5, Page6, Page7, Page8, Page9, Page10, Page11, Page12, Page13, Page14, Page15, Page16, LoadingOutlined, Vicon},
    setup() {
        const route = useRoute()
        const data = reactive({
            id:null,
        })

        

        //引入数据管理库
        const PdftStore = usePdftStore()
        const router = useRouter()

        /**
         * @description: 加载组件
         * @return {*}
         */
         const indicator = h(LoadingOutlined, {
            style: {
                fontSize: '24px',
                color:'#163B7F',
            },
            spin: PdftStore.spinning,
        });

        // 显示隐藏到顶部的按钮
        const scrollFunction = () => {
            let scrollToTopBtn = document.getElementById("scrollToTopBtn");
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                scrollToTopBtn.style.display = "block";
            } else {
                scrollToTopBtn.style.display = "none";
            }
        }

        // 滚动到顶部
        const scrollToTop = () => {
            if (window.scrollTo) {
                window.scrollTo({
                top: 0,
                behavior: "smooth"
                });
            } 
            // For older browsers
            else {
                var position = document.documentElement.scrollTop || document.body.scrollTop;
                if (position) {
                    window.scroll(0, position - 20); // how far to scroll on each step
                    setTimeout("scrollToTop()", 10);
                }
            }
        }

        let pdf = ref(null)
        const downloadPDFs = (v,router) => {
            PdftStore.queid = data.id
            return downloadPDF(v,router)
        }
        const downloadPDFs1 = (v) => {
            return downloadPDF1(v)
        }
        // 导出
        const getpdf = () => {
            PdftStore.spinning = true
            downloadPDFs1(pdf.value)
        };
        // 发送
        const sentpdf = () => {
            PdftStore.spinning = true
            downloadPDFs(pdf.value,router)
        }
        //获取报告详情
        const getReport = () => {
            let params = {
                id:data.id
            }
            PdftStore.spinning = true
            PdftStore.getReport(params)
        }
        const gotopath = () => {
            router.push('/scoring')
        }
        //切换中英文报告
        const changeLanguage = () => {
            router.push({
                path:'/pdfen',
                query:{
                    id:data.id
                }
            })
        }

        /**
         * @description: 清空对象
         * @param {*} obj
         * @return {*}
         */
        const resetObj = (obj) => {
            Object.keys(obj).forEach((key) => {
                obj[key] = null
            })
        }

        onBeforeMount(() => {
            data.id = route.query.id;//获取报告id
            getReport()
            window.onscroll = () => { scrollFunction() };
        })
        onBeforeUnmount(() => {
            resetObj(PdftStore.fromData)
        })
        onMounted(() => {
            
        })
        return {
            pdf,
            getpdf,
            sentpdf,
            getReport,
            PdftStore,
            gotopath,
            changeLanguage,
            indicator,
            scrollToTop,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.pdf_box{
    width: 100vw;
}
.btn{
    text-align: right;
    margin: 20px;
}
.pdf{
    font-family: PingFangSC-Medium, PingFang SC !important;
    margin: 0 auto;
}

.box{
    position: fixed;
    bottom: 50px;
    right: 20px;
    z-index: 9999;
    &-bn{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: #ffffff;
        transition: background-color 0.2s;
        box-shadow: 0 2px #00000004;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        margin-top: 24px;
        cursor: pointer;
        &:hover{
            background: #364F6B;
            .icon{
                color: #FFFFFF;
            }
        }
        .icon{
            font-size: 24px;
        }
    }
    #scrollToTopBtn {
        display: none;
        transition: display 0.2s;
    }
}
:deep(.ant-spin) {
   max-height: 100vh !important;
}
</style>